import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  aspect-ratio: 210/71;
  height: 100%;
  width: auto;
`;

const Path = styled.path`
  transition: 0.25s stroke;
`;

const HandwriteEllipse = ({ color = "black" }: { color?: string }) => (
  <Wrapper
    width={210} height={71}
    viewBox="0 0 210 71"
    fill="none"
  >
    <Path d="M208.5 48.5C182.849 63.2642 171.69 68.7629 119.61 68.9942C91.079 69.121 64.3277 67.1768 41.4662 61.0128C13.8354 53.5628 -4.68893 43.2815 4.28271 31.0077C11.2083 21.5331 32.6364 13.1292 56.1847 7.92431C76.731 3.38293 108.263 -0.134401 132.004 3.51959C155.906 7.19822 168.67 15.2252 175.094 23.523C179.293 28.9453 181.945 34.7277 181.389 40.347C180.734 46.9546 174.384 52.6682 170.253 59.0257"
      stroke={color}
      strokeWidth={3}
      strokeLinecap="round"
    />
  </Wrapper>
)

export default HandwriteEllipse;